export default "__VITE_ASSET__y_M6AczA__"